var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"signly-logo"}},[_c('img',{attrs:{"src":_vm.src,"height":_vm.logoHeight,"width":_vm.logoHeight,"alt":"Signly logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }